/*
    LIGHTBOX_CAROUSEL.JS

    A SIMPLE helper for the Siema carousel (mobile/tablet)
     - eventListeners is optional object of things to listen to since Siema doesnt have any to begin with
    TODO: we dont plan to use Siema long term and move to Swiper so dont invest too much into it
*/

import { enableHotspots } from "./lightbox_helpers";
import { HotspotsHelper } from "./lightbox";
import { Siema } from "../../../vendor_modified/siema/siema.es5";

export function PixleeCTACarousel(selector, bleed) {
    var ctaCarousel;
    var totalNumCta = 0;
    this.startCtaIndex = 0;

    this.initialize = function() {
        if (ctaCarousel || $(selector).length == 0) {
            return;
        }

        var options = {
            selector: selector,
            startIndex: this.startCtaIndex,
            bleed: bleed, // Whether we show the edges of the previous and next carousel item on screen
            onInit: function() {
                toggleArrow(this);
            },
            onChange: function() {
                toggleArrow(this);

                if (enableHotspots) {
                    HotspotsHelper.setCtaProductIndex(this.currentSlide, true);
                    $(selector).trigger('carouselChange', HotspotsHelper.getCtaProductIndex());
                }
            }
        };

        if (bleed) {
            options.onInit = function() {
                $(selector).attr('class', 'ready');
            };
        }

        try {
            ctaCarousel = new Siema(options);
        } catch (error) {
            console.error(error);
            this.destroy();
        }
    };

    this.reset = function() {
        ctaCarousel.destroy();
        this.initializeCtaCarousel();
    };

    this.destroy = function() {
        if (!ctaCarousel) {
            return;
        }
        ctaCarousel.destroy();
        ctaCarousel = null;
    };

    this.paginate = function(direction) {
        if (direction === 'next') {
            ctaCarousel.next();
        } else {
            ctaCarousel.prev();
        }

        return ctaCarousel.currentSlide;
    };

    this.getCurrentIndex = function() {
        return ctaCarousel.currentSlide;
    };

    this.goToIndex = function(index) {
        if (ctaCarousel.currentSlide === index) {
            toggleArrow(ctaCarousel);
        }
        return ctaCarousel.goTo(index);
    };

    this.setStartCtaIndex = function(index, numElements) {
        this.startCtaIndex = index;
        totalNumCta = numElements;

        if (ctaCarousel) {
            this.goToIndex(index);
        }

        if (enableHotspots) {
            HotspotsHelper.setCtaProductIndex(index, true);
        }
    };

    // MULTIPLE products, switching between them now
    var toggleArrow = function(carousel) {
        var ctaNext = $('#cta_next');
        var ctaPrev = $('#cta_prev');

        var allowNext = totalNumCta > 1 && carousel.currentSlide < totalNumCta - 1;
        var allowPrev = totalNumCta > 1 && carousel.currentSlide > 0;

        ctaNext.toggleClass('active', allowNext);
        ctaPrev.toggleClass('active', allowPrev);
    };
}
